import { initialProps } from '@utils/initial'
import Error from './404'
import { parseFormData } from '@group-devs/yfp7-global-modules/utils/general'
import Link from 'next/link'
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import {HomeWellnessLayout} from '@components/Block'
import Authenticator from '@group-devs/yfp7-authenticator'
import Spinner from 'react-bootstrap/Spinner'
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useEffect, useState } from 'react'


export async function getServerSideProps({req, res, query}) {
    const props = await initialProps(req, res, query)

    if (typeof props.err !== 'undefined') {
        return { props }
    }

    // Reference login must finish before applying the guest-only redirect.
    const reference = Array.isArray(query.ref) ? query.ref[0] : query.ref

    if (props.auth?.isAuthenticated === true && !reference) {
        return {
            redirect: {
                destination: '/home',
                permanent: false,
            },
        }
    }

    return { props }
}

function YWPLogin(props) {
    console.log('login-props:',props);

    if (typeof props.err !== "undefined")
        return <Error statusCode={props.err.code} />

    const [validationUrl, setValidationUrl] = useState('')
    const [passwordResetUrl, setPasswordResetUrl] = useState('')

    useEffect(() => {
        let url, host;
        host = new URL(window.location.href)
        url  = new URL(`${host.protocol}//${host.host}/api/authenticate`)
        url.searchParams.append('continue', '/home')
        setValidationUrl(url)

        let query = new URLSearchParams(host.search)
        let ref = query.get('ref')
        if(ref){
            url  = new URL(`${host.protocol}//${host.host}/api/autoLogin`)
            autoLogin(ref, url)
        }

        if(props.reload && !ref) {
            window.location.reload()
        }
        
        let recovery = Authenticator.getPasswordResetUrl(host, process.env.authDomain);
        setPasswordResetUrl(`${recovery}&from=wellness-center`)

        async function autoLogin(ref, url){
            
            let data = {
                csrf: props.metadata.csrf,
                domain: props.site.url, 
                ref: ref,
                websiteId: props.site.websiteId,
            }
            
            let postData = { ...data }

            const _response = await fetch(url, {
                method: 'POST',
                headers: Authenticator.getJSONHeaders(),
                body: JSON.stringify(postData)
            })
            .then((response) => { return response.json() })
            .then((data) => {return data}).catch((error) => {
                console.log(error)
            })
    
            if (typeof _response === 'object'){
                if (_response.code === 200) {
                    if (typeof window !== 'undefined') {
                        window.location.href = '/home'
                    }
                }
            }
        }

        checkActivationParams();
    }, [])
    
    function checkActivationParams() {
        const params = new URLSearchParams(window.location.search);
        const activationError = params.get('activation_error');
        const activationSuccess = params.get('activation_success');

        if (activationError) {
            showAlert(activationError, 'danger');
            window.history.replaceState({}, '', window.location.pathname);
        }

        if (activationSuccess) {
            showAlert('Your account has been verified! You may now log in.', 'success');
            window.history.replaceState({}, '', window.location.pathname);
        }
    };

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const [alertStatus, setAlertStatus] = useState('danger')
    const [rememberMe, setRememberMe] = useState('')
    const [loader, setLoader] = useState(false)

    const [validEmail, setValidEmail] = useState(true)
    const [validPassword, setValidPassword] = useState(true)

    const [inValidEmail, setInValidEmail] = useState(true)
    const [inValidPassword, setInValidPassword] = useState(true)

    const [colorEmail, setColorEmail] = useState('#000')
    const [colorPassword, setColorPassword] = useState('#000')
    
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    function showAlert(message, status = 'danger') {
        setErrorMessage(message)
        setAlertStatus(status)
    }

    function clearInvalidEmailAlert() {
        if (errorMessage === 'Please enter a valid email address.') {
            setErrorMessage('')
            setAlertStatus('danger')
        }
    }

    function isValidEmail(email) {
        return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email.trim());
    }

    function focusHandler(e) {
        
        if(e == 'password'){
            setValidPassword(true)
            setColorPassword('#000')
        }
        else if(e == 'email'){
            setValidEmail(true)
            setColorEmail('#000')
            clearInvalidEmailAlert()
        }

    }

    function blurEmailHandler(e){

        if(e != ''){
            if (isValidEmail(e)) {
                clearInvalidEmailAlert()
                setInValidEmail(false)
                setColorEmail('#28a745')
            } else {
                setInValidEmail(true)
                setValidEmail(true)
                setColorEmail('#000')
            }
        }else{
            clearInvalidEmailAlert()
            setInValidEmail(true)
            setValidEmail(true)
            setColorEmail('#000')
        }
        setEmail(e)
    }

    function blurPasswordHandler(e){

        if(e != ''){
            
            setInValidPassword(false)
            setValidPassword(true)
            setColorPassword('#28a745')
            
        }else{
            setInValidPassword(true)
            setValidPassword(true)
            setColorPassword('#000')
        }

        setPassword(e)
        
    }
    
    const togglePasswordVisibility = () => {
        setIsPasswordVisible(!isPasswordVisible); // Toggle the visibility
    };

    async function submitLogin(event) {
        event.preventDefault()

        // Clear error message on submit
        setErrorMessage('')
        setAlertStatus('danger')
        setLoader(true)

        let prePostData = {
            csrf: props.metadata.csrf,
            websiteId: props.site.websiteId
        }

        let postData = new FormData(event.target)
        let parseData = parseFormData(postData)
        postData = { ...parseData, ...prePostData }

        const password = parseData.password;
        const email = parseData.email;

        if(password == ""){
            showAlert('All fields are required', 'danger');
            setLoader(false)
            setValidPassword(false)
            setColorPassword('#ff0000')
        }

        if(email == ""){
            showAlert('All fields are required', 'danger');
            setLoader(false)
            setValidEmail(false)
            setColorEmail('#ff0000')
        }

        if(!isValidEmail(email)){
            showAlert('Please enter a valid email address.', 'danger')
            setValidEmail(false)
            setColorEmail('#ff0000')
            setLoader(false)
            return
        }

        function handleSuccess(data) {
            if (data.token === null)
                showAlert(data.message, 'danger')
            setLoader(false)
            return data
        }


        if(password != "" && email != ""){
            const _response = await fetch(validationUrl, {
                method: 'POST',
                headers: Authenticator.getJSONHeaders(),
                body: JSON.stringify(postData)
            })
            .then((response) => { return response.json() })
            .then((data) => handleSuccess(data)).catch((error) => {
                console.log(error)
            })
            
            console.log('_response:',_response);

            if (typeof JSON.parse(_response) === 'object'){
                let responseObj = JSON.parse(_response)
                if (responseObj.code === 200) {
                    if (typeof window !== 'undefined') {
                        window.location.href = '/home'
                    }
                } else {
                    let html = responseObj.message
                    let cleanText = html.replace(/<\/?[^>]+(>|$)/g, "");

                    let resultEmail = cleanText.includes("email");
                    let resultPassword = cleanText.includes("password");

                    if(resultEmail){
                        setValidEmail(false)
                        setColorEmail('#ff0000')
                        setInValidEmail(true)
                    }

                    if(resultPassword){
                        setValidPassword(false)
                        setColorPassword('#ff0000')
                        setInValidPassword(true)
                    }

                    if (responseObj.code === 401) {
                        const resendVerificationEmailURL = responseObj.resendVerificationEmailURL;

                        const handleResend = () => {
                            showAlert('Sending verification email...', 'danger');
                            fetch(resendVerificationEmailURL)
                                .then(res => res.json())
                                .then(data => {
                                    if (data.code === 200) {
                                        showAlert('Verification email resent! Please check your inbox.', 'success');
                                    } else {
                                        showAlert(data.message || 'Failed to resend. Please try again.', 'danger');
                                    }
                                })
                                .catch(() => {
                                    showAlert('Something went wrong. Please try again.', 'danger');
                                });
                        };

                        showAlert(
                            <>
                                {cleanText}
                                <br />
                                Click <a href="#" onClick={(e) => { e.preventDefault(); handleResend(); }}>
                                    here
                                </a> to resend the verification email.
                            </>,
                            'danger'
                        );
                    } else {
                        showAlert(cleanText, 'danger');
                    }
                }
            }

        }
    }
  

    return (
        <HomeWellnessLayout global={props}>
            <div className="ywp__Login h-100 text-dark">
                <Container className="position-relative">
                    <Row className="position-relative">
                        <Col lg={6} md={12} sm={12} className="ywp__Login--left bg-white px-4 py-4">
                            <img src="../images/login/img-wellness-center-logo02.png" alt="Ywp Logo" className="img-fluid mx-auto d-block" width="320"></img>
                            <h3 className="mb-4">Member Login</h3>
                            {errorMessage ? <div className={`alert alert-${alertStatus} mb-3 h7`}>{errorMessage}</div> : ''}
                            <Form onSubmit={submitLogin}>
                                <Form.Group controlId="email">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        name="email"
                                        type="text"
                                        placeholder=""
                                        autoComplete="off"
                                        onFocus={(e) => focusHandler('email')}
                                        onBlur={(e) => blurEmailHandler(e.target.value)}
                                        onClick={(e) => blurEmailHandler(e.target.value)}
                                        onChange={(e) => blurEmailHandler(e.target.value)}
                                        className={`rounded-0 pl-0 ${validEmail == false ? 'is-invalid' : (inValidEmail==false ? 'is-valid' : '') }`}
                                        value={email}
                                        //onChange={(e) => setEmail(e.target.value)}
                                        style={{borderBottom: "2px solid "+colorEmail+""}}
                                    />
                                </Form.Group>
                                <Form.Group controlId="password">
                                    <Form.Label>Password</Form.Label>
                                    <div className="position-relative">
                                        <Form.Control
                                            name="password"
                                            type={isPasswordVisible ? 'text' : 'password'}
                                            placeholder=""
                                            autoComplete="off"
                                            onFocus={(e) => focusHandler('password')}
                                            onBlur={(e) => blurPasswordHandler(e.target.value)}
                                            onClick={(e) => blurPasswordHandler(e.target.value)}
                                            onChange={(e) => blurPasswordHandler(e.target.value)}
                                            className={`rounded-0 pl-0 ${validPassword == false ? 'is-invalid' : (inValidPassword==false ? 'is-valid' : '') }`}
                                            //className="rounded-0 pl-0"
                                            value={password}
                                            //onChange={(e) => setPassword(e.target.value)}
                                            style={{borderBottom: "2px solid "+colorPassword+""}}
                                        />
                                        <div 
                                            className="position-absolute password-icon"
                                            style={{ top: '50%', right: '10px', transform: 'translateY(-50%)', cursor: 'pointer' }}
                                            onClick={togglePasswordVisibility}
                                        >
                                            {isPasswordVisible ? <FaEyeSlash /> : <FaEye />} {/* Toggle between eye slash and normal eye */}
                                        </div>
                                    </div>
                                </Form.Group>
                                <Form.Group controlId="checkbox">
                                    <Form.Check
                                        type="checkbox"
                                        label="Remember Me"
                                        name="remembered"
                                        id="custom-checkbox"
                                        value={rememberMe}
                                        onChange={() => setRememberMe(true)}
                                    />
                                </Form.Group>
                                <Button variant="success" type="submit" className="w-100 my-4 mx-0">
                                    {
                                    (loader) ?
                                        <Spinner animation="border" role="status">
                                            <span className="sr-only"></span>
                                        </Spinner>
                                    :
                                        'Login'
                                    }
                                </Button>
                                <p className="forget__Pword text-center pt-4 pb-3"><a href={passwordResetUrl}>Forgot Password?</a></p>
                            </Form>
                        </Col>
                        <Col lg={6} md={12} sm={12} className="ywp__Login--right align-self-end">
                            <div className="ywp__Login--box px-5 py-4 text-white">
                                <h3 className="mb-3 text-white">Don't have an account yet?</h3>
                                <p>Get FREE access to my Wellness Center and discover <br className="d-xl-block d-none" />
                                    how to create long lasting vitality and well-being.</p>
                                <Link href="/"><a className="d-inline-block text-white py-2 px-3 mb-3">Create your FREE account</a></Link>
                            </div>
                        </Col>
                    </Row>
                    <div className="ywp__Login--woman position-absolute">
                        <img src="../images/login/img-woman-apple01.png" alt="Woman" className="img-fluid mx-auto d-block"></img>
                    </div>
                </Container>
            </div>
            <style jsx global>{`
                .ywp__Login .container {
                    padding: 120px 15px;
                }
                .ywp__Login .btn{
                    padding: 12px 80px;
                    font-size: 1.1rem;
                    background-color: #43a649!important;
                    border-radius: 50px;
                    box-shadow: none!important;
                    outline: none;
                    font-weight: 700;
                    border-color: #43a649;
                }
                .ywp__Login .form-group .form-control {
                    border:none;
                    height: 40px;
                    border-bottom: 2px solid #000;
                    box-shadow: none;
                }
                .ywp__Login .ywp__Login--right {
                    color: #4b4c4e;
                    z-index: 1;
                }
                .ywp__Login .ywp__Login--right h3 {
                    font-size: 1.5rem;
                }
                .ywp__Login .ywp__Login--right .ywp__Login--box p {
                    font-size: 1rem;
                }
                .ywp__Login .ywp__Login--right a {
                    font-size: 0.9rem;
                    border: 1px solid #fff;
                    border-radius: 50px;
                    font-weight: 700;
                }
                .ywp__Login .ywp__Login--right a:hover {
                    background-color: #fff;
                    color: #000!important;
                    text-decoration: none;
                }
                .ywp__Login .ywp__Login--right .ywp__Login--box {
                    background-color: rgba(67, 166, 73, 0.93);
                }
                .ywp__Login .ywp__Login--left{
                    max-width: 48%!important;
                }
                .ywp__Login .ywp__Login--left h3 {
                    font-weight: 700;
                    color: #000;
                    font-size: 2rem;
                    margin: 45px 0 30px;
                }
                .ywp__Login .is-valid.form-control + .password-icon,
                .ywp__Login .is-invalid.form-control + .password-icon{
                   right: 30px!important;
                }
                @media(max-width:991px){
                    .ywp__Login .ywp__Login--right {
                        padding: 0rem;
                        }
                    .ywp__Login .ywp__Login--left{
                        max-width: 100%!important;
                        }
                    }
                @media (max-width: 640px){
                    .ywp__Login .container {
                        padding: 20px 15px;
                        }
                    .ywp__Login .ywp__Login--right{
                        background: url(../images/login/img-bg-mobile01.jpg) no-repeat top;
                        background-size: cover;
                        }
                    .ywp__Login .ywp__Login--right .ywp__Login--box{
                        background-color: transparent;
                        text-align: center;
                        }
                    }
                `}
            </style>
            <style jsx>{`
                .ywp__Login {
                    background:url(../images/login/img-bg-wellness-login01.jpg) no-repeat center;
                    background-size: cover;
                    font-family: 'Montserrat' ,sans-serif;
                    overflow: hidden;
                }
                .ywp__Login .ywp__Login--woman{
                        top: 79px;
                        right: -385px;
                    }
                .ywp__Login .forget__Pword a {
                        color: #000!important;
                        font-weight: 600px;
                    }

                @media (max-width: 1199px){
                .ywp__Login .ywp__Login--woman{
                    width: 88%!important;
                    top: 80px!important;
                    }
                }
                @media(max-width:991px){
                    .ywp__Login .ywp__Login--woman{
                        display: none;
                        }
                    }
                    @media (max-width: 640px){
                    .ywp__Login{
                        background-image: none!important;
                        }import { Authenticator } from 'authenticator';

                    }

                `}
            </style>
        </HomeWellnessLayout>
    )
}

export default YWPLogin
